module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"volskaya.ink","short_name":"volskaya.ink","description":"Персональный сайт Марины Вольской: визуальные проекты, графика и дизайн.","start_url":"/","background_color":"#f8f5f0","theme_color":"#1c1c1c","display":"standalone","lang":"ru","icon":"static/favicon.png","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"51adc0c1b95a2908113e8260f4c998ef"},
    },{
      plugin: require('../gatsby-browser.jsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
